import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';

import I18n from 'PMT/i18n/I18n';

// -- actions
import RestaurantMenuAction from 'actions/RestaurantMenuAction';

// -- constants
import Events from 'constants/Events';

// -- stores
import RestaurantMenuStore from 'stores/RestaurantMenuStore';

// -- utils
import { StringUtils } from 'PMT/utils';

// -- entities
import UpsellingCategory from 'PMT/entities/menu/UpsellingCategory';
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu';
import Product from 'PMT/entities/menu/Product';
import Menu from 'PMT/entities/menu/Menu';
import CategoryItem from 'PMT/entities/menu/CategoryItem';

// -- views
import AbstractComponent from 'components/AbstractComponent';
import ProductItem from './components/ProductItem';
import MenuItem from './components/MenuItem';
import SearchBox from 'PMT/components/SearchBox';
import SubmitArea from 'PMT/components/form/SubmitArea';
import { Tabs, Tab } from 'react-bootstrap';

class AddItemToUpsellingCategoryView extends AbstractComponent {

  static propTypes = {
    upsellingCategory: PropTypes.instanceOf(UpsellingCategory),

    restaurantMenu: PropTypes.instanceOf(RestaurantMenu)
  };

  state = {
    searchQuery: '',

    upsellingCategory: this.props.upsellingCategory.copy(),

    productAddSearchQuery: '',

    productRemoveSearchQuery: '',

    menuAddSearchQuery: '',

    menuRemoveSearchQuery: ''
  };

  componentDidMount() {
    RestaurantMenuStore.addListener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

    RestaurantMenuStore.addListener(Events.END_LOADING, this.hideLoading);
  }

  componentWillUnmount() {
    RestaurantMenuStore.removeListener(Events.ON_UPDATE_RESTAURANT_MENU_ERROR, this.onError);

    RestaurantMenuStore.removeListener(Events.END_LOADING, this.hideLoading);
  }


  get restaurantMenu(): RestaurantMenu {
    return this.props.restaurantMenu;
  }

  get upsellingCategory(): UpsellingCategory {
    return this.state.upsellingCategory;
  }

  get haveModifications(): boolean {
    return !this.state.upsellingCategory.equals(this.props.upsellingCategory);
  }

  // --
  onError = () => {
    // TODO: onError
  };

  // --
  onDeselectProduct = (product: Product) => {
    const upsellingCategory = this.upsellingCategory;

    upsellingCategory.removeItemWithId(product.id);

    this.setState({
      upsellingCategory
    });
  };

  onSelectProduct = (product: Product) => {
    const upsellingCategory = this.upsellingCategory;

    const item: CategoryItem = new CategoryItem();
    item.type = CategoryItem.Type.PRODUCT;
    item.id = product.id;

    upsellingCategory.items.push(item);

    this.setState({
      upsellingCategory
    });
  };

  onDeselectMenu = (menu: Menu) => {
    const upsellingCategory = this.upsellingCategory;

    upsellingCategory.removeItemWithId(menu.id);

    this.setState({
      upsellingCategory
    });
  };

  onSelectMenu = (menu: Menu) => {
    const upsellingCategory = this.upsellingCategory;

    const item: CategoryItem = new CategoryItem();
    item.type = CategoryItem.Type.MENU;
    item.id = menu.id;

    upsellingCategory.items.push(item);

    this.setState({
      upsellingCategory
    });
  };

  // -- search
  onProductAddSearchQueryChange = (productAddSearchQuery) => {
    this.setState({
      productAddSearchQuery
    });
  };

  onProductRemoveSearchQueryChange = (productRemoveSearchQuery) => {
    this.setState({
      productRemoveSearchQuery
    });
  };

  onMenuAddSearchQueryChange = (menuAddSearchQuery) => {
    this.setState({
      menuAddSearchQuery
    });
  };

  onMenuRemoveSearchQueryChange = (menuRemoveSearchQuery) => {
    this.setState({
      menuRemoveSearchQuery
    });
  };

  // -- form
  onSubmit = () => {
    const restaurantMenu: RestaurantMenu = this.props.restaurantMenu;
    restaurantMenu.updateUpsellingCategory(this.state.upsellingCategory);

    this.showLoading();
    RestaurantMenuAction.saveRestaurantMenu(restaurantMenu);
  };

  onReset = () => {
    this.setState({
      upsellingCategory: this.props.upsellingCategory.copy()
    });
  };

  // -- renderers

  renderMenusSelect() {
    return (null);

//    _.each(this.restaurantMenu.menus, (menu:Menu) => {
//      const isSelected = true;
//      items.push(
//        <MenuItem
//          menu={menu}
//          isSelected={isSelected}
//          onSelect={this.onSelectMenu}
//          onDeselect={this.onDeselectMenu}
//        />
//      );
//    });
  }

  renderSearchNoResults() {
    return (
      <p>
        <em>
          {I18n.tr('menu.upselling_category.add_item.search_no_results')}
        </em>
      </p>
    );
  }

  renderProductsSelected(products: Array<Product>) {
    let listView = null;
    if (_.isEmpty(products) && !_.isEmpty(this.state.productRemoveSearchQuery)) {
      listView = this.renderSearchNoResults();
    } else if (_.isEmpty(products) && _.isEmpty(this.state.productRemoveSearchQuery)) {
      listView = (
        <p>
          <em>
            {I18n.tr('menu.upselling_category.add_item.no_item_selected')}
          </em>
        </p>
      );
    } else {
      const sortedProductsList = _.sortBy(products, ['desc'],
        (product: Product): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(product.name).toLowerCase();
        }
      );
      listView = sortedProductsList.map((product: Product) => {
        return (
          <ProductItem
            key={product.id}
            product={product}
            isSelected
            onDeselect={this.onDeselectProduct}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__products__selected">
        <h4>{I18n.tr('menu.upselling_category.add_item.selected')}</h4>

        <SearchBox
          search={this.state.productRemoveSearchQuery}
          onSearchInput={this.onProductRemoveSearchQueryChange}
        />

        <div className="list">
          {listView}
        </div>
      </div>
    );
  }

  renderProductsUnselected(products: Array<Product>) {
    let listView = null;
    if (_.isEmpty(products)) {
      listView = this.renderSearchNoResults();
    } else {
      const sortedProductsList = _.sortBy(products, ['desc'],
        (product: Product): number => {
          // We want a list sorted by alpha-num. We handle special characters like quotes and dots.
          return StringUtils.toAlphaNum(product.name).toLowerCase();
        }
      );
      listView = sortedProductsList.map((product: Product) => {
        return (
          <ProductItem
            key={product.id}
            product={product}
            isSelected={false}
            onSelect={this.onSelectProduct}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__products__unselected">
        <h4>{I18n.tr('menu.upselling_category.add_item.products_on_menu')}</h4>

        <SearchBox
          search={this.state.productAddSearchQuery}
          onSearchInput={this.onProductAddSearchQueryChange}
        />
        <div className="list">
          {listView}
        </div>
      </div>
    );
  }

  renderProducts() {
    const unselected = [];
    const selected = [];

    _.each(this.restaurantMenu.products, (product: Product) => {
      const isSelected = !_.isUndefined(_.find(this.upsellingCategory.items, (item: CategoryItem) => {
        return item.isProduct() && item.id === product.id;
      }));

      if (isSelected) {
        const query: string = this.state.productRemoveSearchQuery;
        if (_.isEmpty(query) || StringUtils.searchStringOn(query, product.name)) {
          selected.push(product);
        }
      } else {
        const query: string = this.state.productAddSearchQuery;
        if (_.isEmpty(query) || StringUtils.searchStringOn(query, product.name)) {
          unselected.push(product);
        }
      }
    });

    return (
      <div className="row add_to_category_view__products">
        {this.renderProductsUnselected(unselected)}
        {this.renderProductsSelected(selected)}
      </div>
    );
  }

  renderMenusSelected(menus: Array<Menu>) {
    let listView = null;
    if (_.isEmpty(menus) && !_.isEmpty(this.state.menuRemoveSearchQuery)) {
      listView = this.renderSearchNoResults();
    } else if (_.isEmpty(menus) && _.isEmpty(this.state.menuRemoveSearchQuery)) {
      listView = (
        <p>
          <em>
            {I18n.tr('menu.upselling_category.add_item.no_menu_selected')}
          </em>
        </p>
      );
    } else {
      listView = menus.map((menu: Menu) => {
        return (
          <MenuItem
            key={menu.id}
            menu={menu}
            isSelected
            onDeselect={this.onDeselectMenu}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__menus__selected">
        <h4>{I18n.tr('menu.upselling_category.add_item.selected')}</h4>

        <SearchBox
          search={this.state.menuRemoveSearchQuery}
          onSearchInput={this.onMenuRemoveSearchQueryChange}
        />
        <div className="list">
          {listView}
        </div>
      </div>
    );
  }

  renderMenusUnselected(menus: Array<Menu>) {
    let listView = null;
    if (_.isEmpty(menus)) {
      listView = this.renderSearchNoResults();
    } else {
      listView = menus.map((menu: Menu) => {
        return (
          <MenuItem
            key={menu.id}
            menu={menu}
            isSelected={false}
            onSelect={this.onSelectMenu}
          />
        );
      });
    }

    return (
      <div className="col-xs-6 add_to_category_view__menus__unselected">
        <h4>{I18n.tr('menu.upselling_category.add_item.menus_on_menu')}</h4>

        <SearchBox
          search={this.state.menuAddSearchQuery}
          onSearchInput={this.onMenuAddSearchQueryChange}
        />
        <div className="list">
          {listView}
        </div>
      </div>
    );
  }

  renderMenus() {
    const unselected = [];
    const selected = [];

    _.each(this.restaurantMenu.menus, (menu: Menu) => {
      const isSelected = !_.isUndefined(_.find(this.upsellingCategory.items, (item: CategoryItem) => {
        return item.isMenu() && item.id === menu.id;
      }));

      if (isSelected) {
        const query: string = this.state.menuRemoveSearchQuery;
        if (_.isEmpty(query) || StringUtils.searchStringOn(query, menu.name)) {
          selected.push(menu);
        }
      } else {
        const query: string = this.state.menuAddSearchQuery;
        if (_.isEmpty(query) || StringUtils.searchStringOn(query, menu.name)) {
          unselected.push(menu);
        }
      }
    });

    return (
      <div className="row add_to_category_view__menus">
        {this.renderMenusUnselected(unselected)}
        {this.renderMenusSelected(selected)}
      </div>
    );
  }

  renderSubmitArea() {
    return (
      <SubmitArea
        haveModifications={this.haveModifications}
        onSubmit={this.onSubmit}
        onReset={this.onReset}
      />
    );
  }

  render() {
    return (
      <div className="add_to_category_view">
        {this.renderMenusSelect()}

        <Tabs
          defaultActiveKey={1}
          id="edit_restaurant_page__tabs"
          onSelect={this.onTabChange}
        >

          <Tab
            eventKey={1}
            title={I18n.tr('menu.upselling_category.products')}
          >
            <div className="top-buffer-30">
              {this.renderProducts()}
            </div>
          </Tab>

          <Tab
            eventKey={2}
            title={I18n.tr('menu.upselling_category.menus')}
          >
            <div className="top-buffer-30">
              {this.renderMenus()}
            </div>
          </Tab>
        </Tabs>

        {this.renderSubmitArea()}

        {this.renderLoading()}
      </div>
    );
  }

}

export default AddItemToUpsellingCategoryView;
